import { createRoot } from "react-dom/client";

import RootErrorBoundary from "Flocknote/RootErrorBoundary";

import FlocknoteApp from "Flocknote";

import initSentry from "./Utilities/Sentry/initSentry";
import { markPointerType } from "./Utilities/pointerType";
import redirectProfileHashToParam from "./Utilities/redirectProfileHashToParam";
import retryChunkLoads from "./Utilities/retryChunkLoads";
import "./index.scss";

// Retries JS/CSS chunk downloads that fail (a couple tries, then gives up). Needs
// to run before anything lazy renders.
retryChunkLoads();

// Convert a legacy profile-tab hash (e.g. #giving) into ?profileTab=giving before
// react-router reads the URL on first render. Must run before root.render().
redirectProfileHashToParam();

markPointerType();

initSentry();

const container = document.getElementById("fnReactHolder");
const root = createRoot(container);

root.render(
  <RootErrorBoundary>
    <FlocknoteApp />
  </RootErrorBoundary>
);
